export * from './lib/ui-icon.component';
